import React, { useMemo } from 'react';
import { I_SelectedDestinationCommon } from '@Redux/search/interfaces';

const UseDestCount = (selectedDestinationID: I_SelectedDestinationCommon[]) => {
    const destinationCount = useMemo(() => {
        //計算城市跟國家
        const Country = new Map();
        const city = selectedDestinationID.filter((obj) => {
            if (obj.parentId === obj.value) Country.set(obj.parentId, obj.parentId);
            if (!Country.has(obj.parentId)) return obj;
        });
        return city.length + Country.size;
    }, [selectedDestinationID]);
    return destinationCount;
};

export default UseDestCount;
